import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';


const noop = () => {
};

@Component({
  selector: 'adahi-text-area',
  templateUrl: './text-area.component.html',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TextAreaComponent), multi: true },
  ]
})
export class TextAreaComponent implements ControlValueAccessor,   OnInit {
  
  ngOnInit(): void {
    if (this.maxLength == null || this.maxLength == undefined) this.maxLength = 250;
  }
  //The internal data model
  private innerValue: any = '';

  @Input() placeholder: any = '';
  @Input() maxLength: number = 250;
  @Input() isReadOnly : boolean = false; 
  private onChangeCallback: (_: any) => void = noop;
  private onTouchedCallback: () => void = noop;

  //get accessor
  get value(): any {
    return this.innerValue;
  };

  //set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  //From ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

}